import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useEffect, useRef, useState } from "react";
import { ChevronLeft, Clock, Edit, Heart, LogIn, MessageCircle, Send, Smile, Trash, X, XSquare } from "react-feather";
import Spinner, { LoadingThreeCircle } from "../../../global-components/src/components/spinner/spiner";
import { LIMIT_REQUEST_COMMENTS, LIMIT_TEXT_COMMENT } from "../../../utils/vars";
import { useAuth } from "../../../global-components/src";
import axios from "axios";
import { Post as PostType, Comment } from "../../../types";
import { calculateTime, errorMessage } from "../../../utils/TextManagerTwo";
import { useMessage } from "../../../global-components/src";
import ImgVerified from "../../imgVerified/ImgVerified";
import FormVerifyEmail from "../../FormVerifyEmail/FormVerifyEmail";
import EmojiPicker from "../../Textarea/Emojis";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import { getImageUser } from "../../../global-components/src/utils/auth";
import ModalCommentsContent from "./comments-content";

interface ModalCommentsProps {
    show: boolean; // Define que posts é um array de Post
    idPostSelected: number | null; // Define que posts é um array de Post
    idCommentSelectedParam?: number | null; // Define que posts é um array de Post
}
type getCommentsOrResponseType = "response" | "comment";

const ModalComments: React.FC<ModalCommentsProps> = ({ show, idPostSelected, idCommentSelectedParam = null }) => {
    const { id: postId } = useParams();
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPost, setIsLoadingPost] = useState(false);
    const { token, user, isAuthenticated } = useAuth();
    const [loading, setLoading] = useState(true);
    const [post, setPost] = useState<PostType>();
    const openModalLikesRef = useRef<HTMLButtonElement | null>(null);
    const closeModalLikesRef = useRef<HTMLButtonElement | null>(null);
    const [comments, setComments] = useState<any[]>([]);
    const [expandedComments, setExpandedComments] = useState<{ [key: number]: boolean }>({});
    const [isLoadingResponse, setIsLoadingResponse] = useState<number | null>(null);
    const [responsesOffset, setResponsesOffset] = useState<{ [key: number]: number }>({});
    const [text, setText] = useState("");
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [disabled, setDisabled] = useState(true);
    const [isEdditing, setIsEdditing] = useState(false);
    const [idCommentEdit, setIdCommentEdit] = useState(0);
    const [idCommentToResponse, setIdCommentToResponse] = useState<number | null>(null);
    const [idCommentSelected, setIdCommentSelected] = useState<number | null>(idCommentSelectedParam);
    const [commentSelected, setCommentSelected] = useState<Comment | null>(null);
    const [error404, setError404] = useState<string | null>(null);
    const { setMessage } = useMessage();
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const minHeight = 20; // Altura mínima inicial
    const [userNameCommentToResponse, setUserNameCommentToResponse] = useState<string | null>(null);
    const buttonRef = useRef<HTMLDivElement | null>(null);
    const closeModalRef = useRef<HTMLButtonElement | null>(null);
    const navigate = useNavigate();
    const location = useLocation();
    

    useEffect(() => {
        closeModalRef.current?.click();
    }, [location.pathname]); // Executa toda vez que a URL muda

    const cancelEdit = () => {
        setIsEdditing(false);
        setText("");
        setIdCommentEdit(0);
        setIdCommentToResponse(null);
        setIdCommentSelected(null);
        setCommentSelected(null);
        setError404(null);
        idCommentSelectedParam = null;
    };

    const backComment = () => {
        setIsEdditing(false)
        setText("")
        setIdCommentEdit(0)
        setIdCommentToResponse(null);
        setIdCommentSelected(null);
        setCommentSelected(null)
        setOffset(0);
        setHasMore(true);
        setResponsesOffset({});
        setExpandedComments({});
        setError404(null);
        show = true;
        idCommentSelectedParam = null;
    };

    useEffect(() => {
        if (show) {
            openModalLikesRef.current?.click()
        }
        else
            closeModalLikesRef.current?.click()
    }, [show])

    useEffect(() => {
        const handleModalClose = () => {
            setComments([]);
            setIsLoading(false)
            setOffset(0)
            setHasMore(true)
        };

        const modalElement = document.getElementById("modal-comments");
        if (modalElement) {
            modalElement.addEventListener("hidden.bs.modal", handleModalClose);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
            }
        };
    }, []);

    return (
        <div className="modal fade " id={"modal-comments"} style={{zIndex: "17!important"}} aria-hidden="true">
            <div className="modal-dialog modal-dialog-comments modal-dialog-centered cover-mobile" role="document">
                <div className="modal-content modal-content-comments" id="modal-content-likes">
                    <div className="modal-header modal-header-comments">
                        {/* <h5 className="modal-title">Curtidas</h5> */}
                        <h4 className={`modal-title ml-5`} id="modal-curtida">
                            {idCommentSelected ? (
                                <ChevronLeft id="back-comment" onClick={backComment} className="back-comment chevron-comments-left" size="30" />
                            ): null}

                            {idCommentSelected ? "Respostas" : "Comentários"}
                        </h4>

                        <button className="d-none" ref={closeModalRef} data-bs-dismiss="modal" aria-label="Close" type="button" data-bs-target={"#modal-comments"}></button> {/* para fechar ao mudar de pagina */}
                        <button data-bs-dismiss="modal" onClick={() => {backComment(); cancelEdit()}} aria-label="Close" ref={closeModalLikesRef} type="button" className="btn-close"></button>
                    </div>
                    
                    <ModalCommentsContent setIdCommentSelectedParam={setIdCommentSelected} idPostSelected={idPostSelected} open={show} idCommentSelectedParam={idCommentSelectedParam}/>
                </div>

            </div>

            <button className="d-none" ref={openModalLikesRef} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target={"#modal-comments"}>a</button>
        </div>
    );
};

export default ModalComments;
